import React from 'react';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import CourseDetailsManager from './CourseDetailsManager/CourseDetailsManager';
class CourseDetailsManageTab extends React.Component {
    render() {
        const { course } = this.props;
        return (React.createElement("div", null,
            React.createElement(CourseDetailsHeader, null),
            React.createElement(CourseDetailsManager, { courseId: _.get(course, '_id') })));
    }
}
const mapStateToProps = (state) => ({
    course: state.courseDetails.course,
});
export default compose(connect(mapStateToProps))(CourseDetailsManageTab);
